
export class SuspendColllaboratorRequestModel {
    constructor() { }
    
    public CollaboratorId: number;
    public AssignorGuid: string;
    public ManagerGuid: string;
    public Reason: string;
    public StartDateSuspension: Date;
    public EndDateSuspension: Date;
}
